import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { gruhUdhyogVariantService } from "@project/services/admin/gruh-udhyog-variant.service";
import { gruhUdhyogStockService } from "@project/services/admin/gruh-udhyog-stock.service";
import type { StockEntry, StockEntryPayload } from "@project/types/gruh-udhyog";

const fields: Field[] = [
  {
    name: "variant",
    label: "Product Variant",
    required: true,
    showInTable: true,
    lookup: { table: "product-variants", labelField: "variant_sku" },
  },
  {
    name: "quantity",
    label: "Quantity",
    type: "number",
    required: true,
    showInTable: true,
    placeholder: "e.g. 100",
  },
  {
    name: "notes",
    label: "Notes",
    type: "textarea",
    showInTable: true,
    placeholder: "Reason for stock adjustment...",
  },
];

function toPayload(payload: Record<string, unknown>): StockEntryPayload {
  return {
    variant: Number(payload.variant),
    quantity: Number(payload.quantity),
    notes: payload.notes ? String(payload.notes).trim() : undefined,
  };
}

export default function StockEntriesPage() {
  return (
    <AdminShell
      title="Stock Entries"
      subtitle="Track home industry inventory additions and adjustments"
    >
      <ApiResourceTable<StockEntry>
        title="Stock Entry"
        labelField="id"
        fields={fields}
        searchFields={["notes", "variant_sku"]}
        defaultValues={{}}
        csvFileName="stock-entries"
        lookupSearchLoaders={{
          variant: query => gruhUdhyogVariantService.listLookup(query),
        }}
        list={query => gruhUdhyogStockService.listPage(query)}
        loadRecordForEdit={id => gruhUdhyogStockService.get(id)}
        create={payload => gruhUdhyogStockService.create(toPayload(payload))}
        update={(id, payload) =>
          gruhUdhyogStockService.update(id, toPayload(payload))
        }
        remove={id => gruhUdhyogStockService.delete(id)}
      />
    </AdminShell>
  );
}
